// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"70e799dc","453":"1296793a","455":"55633976","977":"c2617356"}[chunkId] + ".chunk.js";
};